import { Card, Form, Button, InputNumber, message, Select } from "antd"
import * as API from "common/api"
import * as COMMONS from "common/common"
import "moment/locale/ja"
import React, { useEffect, useState } from "react"
import { useMutation, useQuery, useQueryClient } from "react-query"
import { Helmet } from "react-helmet-async"
import { useNavigate } from "react-router-dom"

const Tax = (props) => {
  const navigate = useNavigate()

  const isMountedRef = COMMONS.USE_IS_MOUNTED_REF()
  const queryClient = useQueryClient()

  const [taxSettingsForm] = Form.useForm()

  const [taxSettings, setTaxSettings] = useState({})

  useQuery(
    [API.QUERY_KEY_ADMIN_TAX_SETTINGS],
    () => API.ADMIN_GET_TAX_SETTINGS(),
    {
      onSuccess: (response) => {
        if (isMountedRef.current) {
          setTaxSettings(response?.data || {})
        }
      },
      onError: (error) => {
        if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
          navigate(COMMONS.PERMISSION_ERROR_ROUTE)
        } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
          message.warning(COMMONS.ERROR_SESSION_MSG)
          navigate(COMMONS.ADMIN_LOGIN_ROUTE)
        } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
          message.error(COMMONS.ERROR_SYSTEM_MSG)
        } else {
          message.error(COMMONS.ERROR_SYSTEM_MSG)
        }
      },
    },
  )

  const taxSettingsMutation = useMutation(API.ADMIN_UPDATE_TAX_SETTINGS, {
    onSuccess: () => {
      if (isMountedRef.current) {
        message.success(COMMONS.SUCCESS_SAVE_MSG)
        queryClient.invalidateQueries(API.QUERY_KEY_ADMIN_TAX_SETTINGS)
      }
    },
    onError: (error) => {
      if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
        navigate(COMMONS.PERMISSION_ERROR_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
        message.warning(COMMONS.ERROR_SESSION_MSG)
        navigate(COMMONS.ADMIN_LOGIN_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      } else {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      }
    },
  })

  useEffect(() => {
    taxSettingsForm.setFieldsValue({
      taxRate: taxSettings?.taxRate ?? undefined,
      taxRoundingDivision: taxSettings?.taxRoundingDivision ?? undefined,
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taxSettings])

  const handleTaxSettings = (data) => {
    const paramData = {
      taxRate: data?.taxRate,
      taxRoundingDivision: data?.taxRoundingDivision,
    }

    taxSettingsMutation.mutate(paramData)
  }

  return (
    <>
      <Helmet>
        <title>税率設定 | {process.env.REACT_APP_SYSTEM_NAME}</title>
      </Helmet>
      <Card
        title="税率設定"
        className="animate__animated animate__fadeIn"
        bordered={false}
      >
        <Card
          type="inner"
          title="消費税率設定"
          extra={
            <Button
              type="primary"
              size="large"
              className="w-32 m-1"
              onClick={() => {
                taxSettingsForm.submit()
              }}
            >
              保存
            </Button>
          }
        >
          <Form
            form={taxSettingsForm}
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            labelAlign="left"
            initialValues={{
              taxRate: undefined,
              taxRoundingDivision: undefined,
            }}
            onFinish={handleTaxSettings}
            requiredMark={false}
            colon={false}
            size="large"
            scrollToFirstError
          >
            <Form.Item
              name="taxRate"
              label="消費税率"
              rules={[
                {
                  required: true,
                  message: "必須です",
                },
              ]}
            >
              <InputNumber
                placeholder="例：10"
                addonAfter="％"
                min={0}
                type="number"
                onPressEnter={(e) => {
                  e.preventDefault()
                }}
              />
            </Form.Item>
            <Form.Item
              name="taxRoundingDivision"
              label="税丸め"
              rules={[
                {
                  required: true,
                  message: "必須です",
                },
              ]}
            >
              <Select
                options={COMMONS.TAX_ROUNDING_DIVISIONS}
                placeholder="税丸めを選択してください"
              />
            </Form.Item>
          </Form>
        </Card>
      </Card>
    </>
  )
}

export default Tax
